import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import { Styles } from "./styles/mobileMenu.js";
import { useState } from "react";

function MobileMenu() {
    const [isScrolled, setIsScrolled] = useState(false);
    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 50);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    useEffect(() => {
        // Mobile Menu
        const hmBtn = document.getElementById("mb-sidebar-btn");


        if (hmBtn) {
            const mdSidebarOverlay = document.getElementById("mb-sidebar-overlay");
            const mdSidebarBody = document.getElementById("mb-sidebar-body");
            const mdSidebarExit = document.getElementById("close-mb-sidebar");

            hmBtn.addEventListener("click", function (e) {
                e.preventDefault();
                mdSidebarOverlay.classList.toggle("visible");
                mdSidebarBody.classList.toggle("opened");
            });

            mdSidebarOverlay.addEventListener("click", function (e) {
                e.preventDefault();
                mdSidebarOverlay.classList.remove("visible");
                mdSidebarBody.classList.remove("opened");
            });

            mdSidebarExit.addEventListener("click", function (e) {
                e.preventDefault();
                mdSidebarOverlay.classList.remove("visible");
                mdSidebarBody.classList.remove("opened");
            });
        }

        // Menu Accordion -----------------
        const menuButton = document.querySelectorAll(".mb-menu-button");
        menuButton.forEach(button => {
            button.addEventListener("click", () => {
                button.classList.toggle("active");
                const content = button.nextElementSibling;

                if (button.classList.contains("active")) {
                    content.className = "mb-menu-content show";
                    content.style.maxHeight = content.scrollHeight + "px";
                } else {
                    content.className = "mb-menu-content";
                    content.style.maxHeight = "0";
                }
            });
        });
    }, []);

    return (
        <Styles>
            {/* Mobile Menu */}
            <section className={`mobile-menu-area ${isScrolled ? "scrolled" : ""}`}>
                <Container>
                    <Row>
                        <Col md="0" sm="12">

                            <div className="mb-topbar d-flex justify-content-between">
                                <div className="topbar-item">
                                    <p><i className="las la-phone"></i>+91 7599020021</p>
                                </div>
                                <div className="topbar-item">
                                    <p><i className="las la-envelope"></i>info@erptechpro.in</p>
                                </div>
                            </div>

                            <div className="mb-logo-area d-flex justify-content-between align-items-center">
                                <div className="mb-logo-box d-flex">
                                    <div className="hm-button">
                                        {/* <a href="/" id="mb-sidebar-btn">
                                                <i className="las la-bars"></i>
                                            </a> */}
                                        <button type="button" id="mb-sidebar-btn">
                                            <i className="las la-bars"></i>
                                        </button>
                                    </div>
                                    <div className="mb-logo">
                                        <Link to="/"><img src="/assets/images/logo2.png" alt="" /></Link>
                                    </div>
                                </div>

                                <div className="mb-search-box">
                                    <Link to="/login" className="login-btn">
                                        <i className="las la-user"></i> Login
                                    </Link>
                                </div>
                            </div>

                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Mobile Menu Sidebar */}
            <section className="mb-sidebar" id="mb-sidebar-body">
                <div className="mb-sidebar-heading d-flex justify-content-between">
                    <div>
                        <h5>Menu</h5>
                    </div>
                    <div>
                        <button type="button" id="close-mb-sidebar">
                            <i className="las la-times"></i>
                        </button>
                    </div>
                </div>

                <div className="mb-sidebar-menu">
                    <ul className="list-unstyled mb-0">
                        <li className="nav-item active"><Link className="nav-link" to="/">Home</Link></li>
                        <li className="nav-item active"><Link className="nav-link" to="/about">About Us</Link></li>
                        <li className="nav-item active"><Link className="nav-link" to="/gallery">Gallery</Link></li>
                        <li className="nav-item active"><Link className="nav-link" to="/course-grid">Courses</Link></li>
                        <li className="nav-item active"><Link className="nav-link" to="/instructor">Instructors</Link></li>
                        <li className="nav-item active"><Link className="nav-link" to="/events">Events</Link></li>
                        <li className="nav-item active"><Link className="nav-link" to="/blog-grid">Blogs</Link></li>
                        <li className="nav-item active"><Link className="nav-link" to="/contact">Contact</Link></li>
                        <li className="nav-item active"><Link className="nav-link" to="/login">Log In</Link></li>
                        <li className="nav-item active"><Link className="nav-link" to="/registration">Apply Now</Link></li>
                    </ul>
                </div>
            </section>
            <div className="mb-sidebar-overlay" id="mb-sidebar-overlay"></div>
        </Styles>
    )
}

export default MobileMenu


